import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ff15f2ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-card"
};
const _hoisted_2 = {
  class: "table-header"
};
const _hoisted_3 = {
  class: "table-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "table-title-bar"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退款订单列表", -1));
const _hoisted_6 = {
  class: "table-total"
};
const _hoisted_7 = {
  key: 0,
  class: "product-name-cell"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  key: 1,
  class: "product-name-cell"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = {
  key: 2,
  class: "id-cell-with-copy"
};
const _hoisted_12 = {
  class: "mono-text"
};
const _hoisted_13 = {
  class: "id-cell-copy-trigger"
};
const _hoisted_14 = {
  class: "pagination-wrap"
};
import { copy } from '@/common';
import IconCopy from '@/components/IconCopy.vue';
import { CopyOutlined } from '@ant-design/icons-vue';
import { getEvidenceStatusTag, getPayStatusTag, getShipStatusTag, tableColumns } from '../data';
export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceTable',
  props: {
    loading: {
      type: Boolean
    },
    total: null,
    pageNum: null,
    pageSize: null,
    dataSource: null
  },
  emits: ["page-change"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const ID_COPY_DATA_INDEXES = ['messageId', 'orderNo'];
    function isIdCopyColumn(dataIndex) {
      return ID_COPY_DATA_INDEXES.includes(String(dataIndex));
    }
    function getIdCellCopyValue(record, dataIndex) {
      const key = String(dataIndex);
      const value = record[key];
      if (value === undefined || value === null) {
        return '';
      }
      return value;
    }
    function formatIdCellDisplay(record, dataIndex) {
      const raw = getIdCellCopyValue(record, dataIndex);
      return raw === '' ? '--' : String(raw);
    }
    function hasIdCellCopyValue(record, dataIndex) {
      const raw = getIdCellCopyValue(record, dataIndex);
      return raw !== '';
    }
    function handleIdCellCopy(record, dataIndex) {
      if (!hasIdCellCopyValue(record, dataIndex)) {
        return;
      }
      copy(String(getIdCellCopyValue(record, dataIndex)));
    }
    function getStatusChipStyle(display) {
      return {
        color: display.color,
        backgroundColor: display.backgroundColor
      };
    }
    const currentPage = ref(props.pageNum);
    const currentPageSize = ref(props.pageSize);
    watch(() => props.pageNum, value => {
      currentPage.value = value;
    });
    watch(() => props.pageSize, value => {
      currentPageSize.value = value;
    });
    const handlePageChange = (page, pageSize) => {
      emit('page-change', page, pageSize);
    };
    const getRowKey = record => {
      return record.id;
    };
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("span", _hoisted_6, "共 " + _toDisplayString(__props.total) + " 条", 1)])]), _createVNode(_component_a_table, {
        class: "evidence-table",
        bordered: "",
        size: "small",
        loading: __props.loading,
        columns: _unref(tableColumns),
        "data-source": __props.dataSource,
        pagination: false,
        "row-key": getRowKey,
        style: _normalizeStyle({
          height: 'calc(100% - 100px)'
        })
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _record$dbtId, _record$prodId, _record$column$dataIn;
          return [column.dataIndex === 'dbtId' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(IconCopy, {
            copyValue: (_record$dbtId = record.dbtId) !== null && _record$dbtId !== void 0 ? _record$dbtId : '',
            copyIconName: "productIDIcon",
            copyIconGreyName: "productIDGreyIcon",
            styleValue: "margin: 0 8px 0 0; flex-shrink: 0; font-size: 19px"
          }, null, 8, ["copyValue"]), _createElementVNode("span", {
            class: "product-name-text",
            title: record.appName || undefined
          }, _toDisplayString(record.appName || '--'), 9, _hoisted_8)])) : column.dataIndex === 'prodId' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(IconCopy, {
            copyValue: (_record$prodId = record.prodId) !== null && _record$prodId !== void 0 ? _record$prodId : '',
            copyIconName: "productIDIcon",
            copyIconGreyName: "productIDGreyIcon",
            styleValue: "margin: 0 8px 0 0; flex-shrink: 0; font-size: 19px"
          }, null, 8, ["copyValue"]), _createElementVNode("span", {
            class: "product-name-text",
            title: record.prodName || undefined
          }, _toDisplayString(record.prodName || '--'), 9, _hoisted_10)])) : isIdCopyColumn(column.dataIndex) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(formatIdCellDisplay(record, column.dataIndex)), 1), _createElementVNode("span", _hoisted_13, [_createVNode(_unref(CopyOutlined), {
            class: _normalizeClass(["id-cell-copy-icon", {
              'id-cell-copy-icon--empty': !hasIdCellCopyValue(record, column.dataIndex)
            }]),
            onClick: _withModifiers($event => handleIdCellCopy(record, column.dataIndex), ["stop"])
          }, null, 8, ["class", "onClick"])])])) : column.dataIndex === 'payStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: "status-chip",
            style: _normalizeStyle(getStatusChipStyle(_unref(getPayStatusTag)(record.payStatus)))
          }, _toDisplayString(_unref(getPayStatusTag)(record.payStatus).label), 5)) : column.dataIndex === 'shipStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 4,
            class: "status-chip",
            style: _normalizeStyle(getStatusChipStyle(_unref(getShipStatusTag)(record.shipStatus)))
          }, _toDisplayString(_unref(getShipStatusTag)(record.shipStatus).label), 5)) : column.dataIndex === 'status' ? (_openBlock(), _createElementBlock("span", {
            key: 5,
            class: "status-chip",
            style: _normalizeStyle(getStatusChipStyle(_unref(getEvidenceStatusTag)(record.status)))
          }, _toDisplayString(_unref(getEvidenceStatusTag)(record.status).label), 5)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [_createTextVNode(_toDisplayString((_record$column$dataIn = record[column.dataIndex]) !== null && _record$column$dataIn !== void 0 ? _record$column$dataIn : '--'), 1)], 64))];
        }),
        _: 1
      }, 8, ["loading", "columns", "data-source", "style"]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_a_pagination, {
        current: currentPage.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        pageSize: currentPageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => currentPageSize.value = $event),
        total: __props.total,
        "show-size-changer": "",
        "show-total": count => `共 ${count} 条`,
        onChange: handlePageChange
      }, null, 8, ["current", "pageSize", "total", "show-total"])])]);
    };
  }
});